import React from 'react';
import PropTypes from 'prop-types';
import { CloseIcon } from '@domain-group/fe-co-icon';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './header.style';

// Workaround for a workaround in Downshift for iOS.
// Downshift implements its own onBlur handling on iOS
// which ends up preventing the click/touch from reaching its target.
// So we'll stop propagation before it reaches Downshift
import { jsx as ___EmotionJSX } from "@emotion/core";
var stopPropagation = event => {
  event.stopPropagation();
};
var Header = props => ___EmotionJSX("div", {
  css: styles.header
}, ___EmotionJSX("div", {
  css: styles.heading
}, ___EmotionJSX("div", {
  css: styles.headingBody
}, props.heading)), ___EmotionJSX("div", null, ___EmotionJSX(Button, {
  onTouchStart: stopPropagation,
  onTouchEnd: stopPropagation,
  appearance: "ghostNeutral",
  icon: ___EmotionJSX(CloseIcon, null),
  onClick: props.handleClose
})));
Header.propTypes = {
  heading: PropTypes.string,
  handleClose: PropTypes.func.isRequired
};
Header.defaultProps = {
  heading: ''
};
export default Header;